export const advisorProfileStatuses = [
  { key: 'draft', title: 'Draft', colorPalette: 'gray' },
  { key: 'applied', title: 'Pending review', colorPalette: 'orange' },
  { key: 'approved', title: 'Approved', colorPalette: 'green' },
  { key: 'rejected', title: 'Rejected', colorPalette: 'red' },
  { key: 'suspended', title: 'Suspended', colorPalette: 'purple' },
].map(x => ({ ...x, id: x.key }))

export const ADVISOR_PROFILE_STATUS_DRAFT = 'draft'
export const ADVISOR_PROFILE_STATUS_APPLIED = 'applied'
export const ADVISOR_PROFILE_STATUS_APPROVED = 'approved'
export const ADVISOR_PROFILE_STATUS_REJECTED = 'rejected'
export const ADVISOR_PROFILE_STATUS_SUSPENDED = 'suspended'
